import { render, staticRenderFns } from "./RefreshComponent.vue?vue&type=template&id=3f8577ae"
import script from "./RefreshComponent.vue?vue&type=script&lang=js"
export * from "./RefreshComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports